module.exports = __webpack_public_path__ + "img/inagesp.716cac65.png";